/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon20Light = forwardRef('ArrowDim1VIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m10.001 2.208.03.03 3.618 3.617a.5.5 0 1 0 .708-.707L10.739 1.53a1.75 1.75 0 0 0-2.475 0L4.646 5.148a.5.5 0 1 0 .708.707L8.97 2.237l.03-.028v15.582a.894.894 0 0 1-.03-.029l-3.616-3.616a.5.5 0 1 0-.707.707l3.616 3.617a1.75 1.75 0 0 0 2.475 0l3.616-3.617a.5.5 0 1 0-.707-.707l-3.616 3.616-.031.03V2.207Z" })));
});
